import Model from "./base/model";

class ExtraPlan extends Model {
  resourceName() {
    return "extra_plans";
  }

  fields() {
    return {
      name: "",
    };
  }
}
export default new ExtraPlan();
